export enum OwnerActionEventsEnum {
  pin = 'pin',
  unpin = 'unpin',
  edit = 'edit',
  delete = 'delete',
}
